export default function FAQSection({ items }) {
  if (!items || items.length === 0) return null;

  return (
    <section className="mt-14 pt-8 border-t border-[#E4E1D8]">
      <h2 className="text-[24px] font-bold text-[#2E3A46] tracking-tight mb-6">
        Ofte stillede spørgsmål
      </h2>
      <div className="space-y-6">
        {items.map((item, idx) => (
          <div key={idx} className="pb-6 border-b border-[#E4E1D8] last:border-b-0">
            <h3 className="text-[18px] font-semibold text-[#2E3A46] mb-2">
              {item.q}
            </h3>
            <p className="text-[#1A1C1F] text-[16px] leading-relaxed m-0">
              {item.a}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
